import React from 'react'
import {lazyDevLogin} from './lazyDevLogin'
import {getFetcher, wrapLazy} from '@startlibs/utils'

lazyDevLogin.promise()
export const lazyStudyUserRights = wrapLazy(() => lazyDevLogin.promise().then(() => getFetcher('/StudyUserRights.php')))